// extracted by mini-css-extract-plugin
export var menuItem = "w_t0 d_fZ d_bz d_bD d_bP d_bf";
export var menuItemSub = "w_t1 d_Z d_bz d_bP";
export var menuMainLink = "w_t2 d_f0 d_dB";
export var menuLink = "w_t3 d_f0 d_dB";
export var icon = "w_p8 d_bC d_bP";
export var divider = "w_t4 d_bC d_bP";
export var sublinks = "w_t5";
export var link = "w_mC";
export var Link = "w_sm s_sm s_rz s_rV";